export type Trackers = Array<string | undefined>;

export function cleanTrackerIds(trackers?: Trackers): string[] {
  if (!Array.isArray(trackers)) {
    return [];
  }

  return trackers.filter(Boolean);
}
